import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

const OemSubscribedVehicleModal = ({ show, onClose, onSubmit, vehicle, oemKey, mode }) => {
  const OEM_OPTIONS = [
    { key: 'bajaj', oem: 'Bajaj' },
    { key: 'euler', oem: 'Euler' },
    { key: 'tata', oem: 'Tata' },
    { key: 'eicher', oem: 'Volvo Eicher' },
    { key: 'nemo', oem: 'Mahindra' },
    { key: 'switch', oem: 'Switch' }
  ]

  const SOURCE_OPTIONS = ['euler', 'bajaj', 'tata', 'eicher', 'nemo', 'switch']

  const defaultOem = OEM_OPTIONS.find(o => o.key === oemKey)?.oem || ''
  const defaultSource = oemKey || ''

  const [formData, setFormData] = useState({
    registrationNumber: '',
    chassisNumber: '',
    model: '',
    oem: defaultOem,
    source: defaultSource,
    note: '',
    vin: '',
    isActive: true
  })

  useEffect(() => {
    if (vehicle && mode === 'edit') {
      setFormData({
        registrationNumber: vehicle.registrationNumber || '',
        chassisNumber: vehicle.chassisNumber || '',
        model: vehicle.model || '',
        oem: vehicle.oem || defaultOem,
        source: vehicle.source || defaultSource,
        note: vehicle.note || '',
        vin: vehicle.vin || '',
        isActive: vehicle.isActive !== false
      })
    } else {
      setFormData({ registrationNumber: '', chassisNumber: '', model: '', oem: defaultOem, source: defaultSource, note: '', vin: '', isActive: true })
    }
  }, [vehicle, mode, defaultOem, defaultSource])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = () => {
    if (!formData.chassisNumber.trim()) return
    if (!formData.registrationNumber.trim()) return

    if (mode === 'edit' && vehicle?._id) {
      // Only send fields that actually changed
      const payload = { oemKey, _id: vehicle._id }
      if (formData.registrationNumber !== (vehicle.registrationNumber || '')) payload.registrationNumber = formData.registrationNumber
      if (formData.chassisNumber !== (vehicle.chassisNumber || '')) payload.chassisNumber = formData.chassisNumber
      if (formData.model !== (vehicle.model || '')) payload.model = formData.model
      if (formData.oem !== (vehicle.oem || '')) payload.oem = formData.oem
      if (formData.source !== (vehicle.source || '')) payload.source = formData.source
      if (formData.note !== (vehicle.note || '')) payload.note = formData.note
      if (oemKey === 'nemo' && formData.vin !== (vehicle.vin || '')) payload.vin = formData.vin
      if (formData.isActive !== (vehicle.isActive !== false)) payload.isActive = formData.isActive
      onSubmit(payload, mode)
    } else {
      const payload = { oemKey, ...formData }
      onSubmit(payload, mode)
    }
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '16px', color: '#1F2A5D' }}>
          {mode === 'edit' ? 'Edit' : 'Add'} Subscribed Vehicle
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='oem-modal-form'>
          <Form.Group>
            <Form.Label>Registration Number <span className='text-danger'>*</span></Form.Label>
            <Form.Control
              type='text'
              name='registrationNumber'
              value={formData.registrationNumber}
              onChange={handleChange}
              placeholder='Enter registration number'
              size='sm'
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Chassis Number <span className='text-danger'>*</span></Form.Label>
            <Form.Control
              type='text'
              name='chassisNumber'
              value={formData.chassisNumber}
              onChange={handleChange}
              placeholder='Enter chassis number'
              size='sm'
            />
          </Form.Group>
          {oemKey === 'nemo' && (
            <Form.Group>
              <Form.Label>VIN</Form.Label>
              <Form.Control
                type='text'
                name='vin'
                value={formData.vin}
                onChange={handleChange}
                placeholder='Enter VIN'
                size='sm'
              />
            </Form.Group>
          )}
          <Form.Group>
            <Form.Label>Model</Form.Label>
            <Form.Control
              type='text'
              name='model'
              value={formData.model}
              onChange={handleChange}
              placeholder='Enter model'
              size='sm'
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>OEM</Form.Label>
            <Form.Control
              as='select'
              name='oem'
              value={formData.oem}
              onChange={handleChange}
              size='sm'
            >
              <option value=''>Select OEM</option>
              {OEM_OPTIONS.map(o => (
                <option key={o.key} value={o.oem}>{o.oem}</option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Source</Form.Label>
            <Form.Control
              as='select'
              name='source'
              value={formData.source}
              onChange={handleChange}
              size='sm'
            >
              <option value=''>Select Source</option>
              {SOURCE_OPTIONS.map(s => (
                <option key={s} value={s}>{s}</option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Note</Form.Label>
            <Form.Control
              as='textarea'
              rows={2}
              name='note'
              value={formData.note}
              onChange={handleChange}
              placeholder='Optional note'
              size='sm'
            />
          </Form.Group>
          {mode === 'edit' && (
            <Form.Group className='mt-2'>
              <Form.Label>Status</Form.Label>
              <Form.Check
                type='switch'
                id='isActive-switch'
                label={formData.isActive ? 'Active' : 'Inactive'}
                checked={formData.isActive}
                onChange={(e) => setFormData(prev => ({ ...prev, isActive: e.target.checked }))}
                style={{ fontSize: '14px' }}
              />
            </Form.Group>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={onClose}>Cancel</Button>
        <Button className='oem-modal-submit' size='sm' onClick={handleSubmit}>
          {mode === 'edit' ? 'Update' : 'Add'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default OemSubscribedVehicleModal
